import { render } from "./PDFWidget.component.vue?vue&type=template&id=6f9ff06a"
import script from "./PDFWidget.component.vue?vue&type=script&lang=js"
export * from "./PDFWidget.component.vue?vue&type=script&lang=js"

import "./PDFWidget.component.vue?vue&type=style&index=0&id=6f9ff06a&lang=css"

import exportComponent from "/home/debian/oni-ui/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__